'use client';

import '../assets/scss/reset.css';
import '../assets/scss/index.scss';
import 'react-datepicker/dist/react-datepicker.css';

import { ReactNode } from 'react';

// containers
import { StyledComponentsRegistry } from 'containers';

// libraries
import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AlertProvider } from 'contexts';
import { RecoilRoot } from 'recoil';
import { DrawerContext, DrawerProvider } from 'contexts/DrawerContext';

export function Providers({ children }: { children: ReactNode }) {
  const queryClient = new QueryClient();
  queryClient.setDefaultOptions({
    queries: {
      refetchOnWindowFocus: false,
      retry: 0
    },
    mutations: {
      retry: 0
    }
  });

  return (
    <html lang="en">
      <body>
        <QueryClientProvider client={queryClient}>
          <StyledComponentsRegistry>
            <AlertProvider>
              <DrawerProvider>
                <AppRouterCacheProvider
                  options={{
                    key: 'css'
                  }}
                >
                  {children}
                </AppRouterCacheProvider>
              </DrawerProvider>
            </AlertProvider>
          </StyledComponentsRegistry>
        </QueryClientProvider>
      </body>
    </html>
  );
}
